import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyEmailComponent } from './verify-email.component';
import { PasswordvalidationComponent } from '../upload-required-documents/passwordvalidation/passwordvalidation.component';
import { VerifyEmailRoutingModule } from './verify-email-routing.module';
import { VerifyEmailService } from './services/verify-email.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material' 
import { UploadRequiredDocumentsComponent } from '../upload-required-documents/uploadrequireddocuments/uploadrequireddocuments.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    VerifyEmailRoutingModule,
    MatTableModule,
    CoreModule,
    ReactiveFormsModule
  ],
  providers:[VerifyEmailService],
  declarations: [
    VerifyEmailComponent,
    PasswordvalidationComponent,
    UploadRequiredDocumentsComponent
    ]
})
export class VerifyEmailModule { }
